/** @jsx jsx */
import { jsx, Box } from "theme-ui"
import { useLocalization } from "gatsby-theme-i18n"
import LocalizedButton from "components/localized-button"
import { useIntl } from "react-intl"

const useLocale = () => {
  const { locale, config, defaultLang } = useLocalization()
  const intl = useIntl()

  const removeLocalePart = pathname => {
    if (locale === defaultLang) {
      return pathname
    }
    const i = pathname.indexOf(`/`, 1)
    return pathname.substring(i)
  }

  let path =
    typeof window !== "undefined"
      ? removeLocalePart(window.location.pathname)
      : "/"

  let locales = config.map(lang => {
    return {
      path,
      label: lang.localName,
      code: lang.code,
    }
  })

  locales = locales.filter(lang => lang.code !== locale)

  const Switcher = props => (
    <Box {...props}>
      {locales.map(lang => (
        <LocalizedButton
          key={lang.code}
          variant="ghost"
          to={lang.path}
          language={lang.code}
          sx={{ textTransform: "uppercase" }}
        >
          {lang.code}
        </LocalizedButton>
      ))}
    </Box>
  )

  const t = id => {
    return intl.formatMessage({ id })
  }

  return {
    locale,
    locales,
    Switcher,
    config,
    defaultLang,
    t,
  }
}

export default useLocale
